import gql from 'graphql-tag';

export const business = gql`
  fragment Business on Business {
    id
    name
    imageUrl
  }
`;
